import {Component, Input, OnInit, NgModule, ViewEncapsulation, Injector, ChangeDetectionStrategy} from '@angular/core';
import {QueryValue} from "../../../../../services/model/queryValue";
import {FilterValue} from "../../../../../services/model/filterValue";
import {EfastFilterBaseComponent} from "../efast-filter-base.component";

@Component({
    selector: 'efast-filter-foreign',
    templateUrl: 'efast-filter-foreign.component.html',
    styleUrls: ['efast-filter-foreign.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class EfastFilterForeignComponent extends EfastFilterBaseComponent implements OnInit {

    constructor(protected injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        this.title= this.cacheService.getLabelFromResource('FILTER:FILTERForeignTitle');

        let filterValues: FilterValue[] = new Array();

        this.filterCategory.filterType = this.staticsService.getFilterType().FOREIGN;

        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERForeignLbl1'),
            this.staticsService.getForeignFilter().ALL, false));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERForeignLbl2'),
            this.staticsService.getForeignFilter().CANADA));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERForeignLbl3'),
            this.staticsService.getForeignFilter().GREAT_BRITAIN_NORTHERN_ISLAND));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERForeignLbl4'),
            this.staticsService.getForeignFilter().BERMUDA));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERForeignLbl5'),
            this.staticsService.getForeignFilter().CAYMAN_ISLANDS));


        this.filterCategory.filterValues = filterValues;

        super.ngOnInit();
    }

    protected expandClick() {
        super.expandClick();
    }

    //extended
    protected searchChangeEvent() {
        this.setBucket(this.applicationService.getAfsForm().facets.countrycode.buckets);
        super.searchChangeEvent();
    }

    //extended
    protected rowClick(filterValue: FilterValue) {

        super.rowClick(filterValue, true);

        this.queryManagerService.addQueryValueNoSearch(this.staticsService.getCategoryType().COUNTRIES, this.queryValue, true)
    }
}